<template>
  <div class="notes-container">
    <p v-on:click="toggle()" class="close">Fermer le bloc-note</p>
    <textarea name="notes" v-model="innerText" @keyup="$emit('update', innerText)"></textarea>
  </div>
</template>

<script>
export default {
  name: "Notes",
  props: { content: String },
  data() {
    return {
      innerText: this.content
    };
  },
  methods: {
    toggle() {
      this.$emit("toggleNote");
    }
  }
};
</script>

<style scoped>
.close {
  background: #cd322b;
  text-align: center;
  font-family: "Permanent Marker", cursive;
  color: white;
  margin: 0;
  width: calc(100% + 20px);
}
.close:hover {
  cursor: pointer;
}
.notes-container textarea {
  background: rgb(235, 235, 235);
  font-family: "IBM Plex Mono", monospace;
  font-size: 14px;
  padding: 10px;
  height: 100%;
  width: 100%;
  overflow: scroll;
}
textarea {
  border: none;
  overflow: auto;
  outline: none;

  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;

  resize: none; /*remove the resize handle on the bottom right*/
}
</style>
